module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleList":{"pagination":{"buttonLoadMore":{"ariaLabel":"Zobrazit další články","text":"Další články"}}}}}')
  delete Component.options._Ctor
}
